import React from 'react'
import PropTypes from 'prop-types'
import { Tooltip, StatusBadge } from 'components'
import {
  ServicesAgreementTooltip,
  ServicesAgreementStatus,
  CombinedServiceAgreementStatus,
} from 'config/automatic-rollovers'
import { AroActionItems } from 'config/portal'
import { Icon as UploadIcon } from 'images/upload-icon.svg'

function AgreementStatusCell({ data, value, handleUploadClick }) {
  const { name, portalAgreementStatus } = data
  const tooltipContent = ServicesAgreementTooltip[portalAgreementStatus]

  if (!portalAgreementStatus)
    return (
      <td className="status">
        <span>{value}</span>
      </td>
    )

  return (
    <td className="status">
      <Tooltip
        offset={[0, 18]}
        content={tooltipContent}
        ariaLabel={tooltipContent}
      >
        <StatusBadge status={portalAgreementStatus} />
      </Tooltip>
      {(portalAgreementStatus === ServicesAgreementStatus.PENDING_SIGNATURES ||
        portalAgreementStatus ===
          CombinedServiceAgreementStatus.COMBINED_PENDING_SIGNATURES) && (
        <button
          type="button"
          className="button-text"
          onClick={() => handleUploadClick(data)}
          aria-label={`${AroActionItems.UPLOAD_SIGNED_AGREEMENT} for ${name}`}
        >
          {AroActionItems.UPLOAD_SIGNED_AGREEMENT}
          <UploadIcon aria-hidden="true" className="upload-icon" />
        </button>
      )}
    </td>
  )
}

AgreementStatusCell.propTypes = {
  data: PropTypes.object.isRequired,
  value: PropTypes.string,
  handleUploadClick: PropTypes.func.isRequired,
}

export default AgreementStatusCell
